import AxiosCustom from "../../../components/common/apiConfig";
import { put, takeLatest } from "@redux-saga/core/effects";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    SelectOptionStatusCkeckQuestin: "SelectOptionStatusCkeckQuestin [Action]",
    SelectOptionStatusCkeckQuestinLoading: "SelectOptionStatusCkeckQuestinLoading [Action]",
    SelectOptionStatusCkeckQuestinAsync: "SelectOptionStatusCkeckQuestinAsync [Action]",
};
const inistiaState = {
    data: {},
    loading: false
};

export const reducerSelecOptionStatusCkeckQuestint = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.SelectOptionStatusCkeckQuestin:
            return {
                ...state,
                data: payload,
            };
        case actionTypes.SelectOptionStatusCkeckQuestinLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.SelectOptionStatusCkeckQuestinLoading, payload: true })


    let config = {
        url: "select_request",
        "token": "3cf61fab-b50a-410f-9d59-3357ee4706fe",
    };

    let data = {
        table: "questionnaire",
        method_type: "member_option_exam_state",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.SelectOptionStatusCkeckQuestin, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.SelectOptionStatusCkeckQuestinLoading, payload: false })

    }
}

export function* selectOptionStatusCkeckQuestint() {
    yield takeLatest(actionTypes.SelectOptionStatusCkeckQuestinAsync, handleWorker);
}
